import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onSearchTextChanged = action(
    'onSearchTextChanged',
    (searchText: string, scenarioId: SearchScenarioId, showSuggestionsUi: boolean) => ({
        searchText,
        scenarioId,
        showSuggestionsUi,
    })
);

export default onSearchTextChanged;
